import * as Yup from 'yup';

export const InitialRegisterFormValue = {
  email: '',
};

export const registerValidationSchema = Yup.object().shape({
  email: Yup.string().email('A valid email address is required').required('A valid email address is required'),
});
